/* ============================================================================
 * ค่าตั้งค่ากลาง — ใช้ร่วมกันระหว่างหน้า "ข้อมูลบริษัท" (settings.js)
 * และหน้า "ลายน้ำรูปภาพ" (watermark.js)
 *
 * สองหน้านี้แยกเมนูกันแล้ว แต่ยังอ่านค่าชุดเดียวกัน — หน้าลายน้ำต้องใช้โลโก้
 * และชื่อบริษัทจากหมวดข้อมูลบริษัทมาแสดงบนกล่องพรีวิว
 * ทั้งสองหน้าดึงค่าจาก GET admin/settings ครั้งเดียวกัน
 * ========================================================================== */

/* ค่าตั้งต้นของฟอร์มลายน้ำ — ตรงกับ default ของตาราง watermark_settings ฝั่ง backend
   ตัวเลขเก็บเป็น string เพราะเป็นค่าใน input/range ที่เป็น controlled component */
export const DEFAULT_WATERMARK = {
  enabled: true,
  source: "logo",          // logo | custom | text
  image: "",               // ใช้เมื่อ source = custom
  text: "",                // ใช้เมื่อ source = text
  position: "bottom_right",
  rotate: "0",             // มุมเอียง -90 ถึง 90 องศา (ลบ = เอียงทวนเข็ม)
  size: "22",              // % ของความกว้างรูป
  opacity: "70",           // %
  margin: "24",            // ระยะห่างจากขอบรูป (px)
  apply_to: "all",         // all = ทุกรูป, cover = เฉพาะรูปปก
};

/* ข้อมูลบริษัทเท่าที่หน้าลายน้ำต้องใช้ — อ่านอย่างเดียว ใช้โชว์บนกล่องพรีวิว */
export const EMPTY_COMPANY_BRIEF = {
  logo: "",
  name_th: "",
  name_en: "",
};

/* ที่มาของลายน้ำ : ใช้โลโก้บริษัท / อัปโหลดรูปใหม่ / ใช้ข้อความ */
export const WATERMARK_SOURCES = [
  { value: "logo", label: "watermark_source_logo" },
  { value: "custom", label: "watermark_source_custom" },
  { value: "text", label: "watermark_source_text" },
];

export const APPLY_TARGETS = [
  { value: "all", label: "watermark_apply_all" },
  { value: "cover", label: "watermark_apply_cover" },
];

/* ตำแหน่งลายน้ำ — เรียงตามตาราง 3x3 (ซ้าย→ขวา, บน→ล่าง) */
export const POSITIONS = [
  { value: "top_left", label: "position_top_left" },
  { value: "top_center", label: "position_top_center" },
  { value: "top_right", label: "position_top_right" },
  { value: "middle_left", label: "position_middle_left" },
  { value: "center", label: "position_center" },
  { value: "middle_right", label: "position_middle_right" },
  { value: "bottom_left", label: "position_bottom_left" },
  { value: "bottom_center", label: "position_bottom_center" },
  { value: "bottom_right", label: "position_bottom_right" },
];

/* มุมเอียงที่ใช้บ่อย — ปุ่มลัดข้างแถบเลื่อน */
export const ROTATE_PRESETS = [
  { value: "0", label: "watermark_rotate_none" },
  { value: "-15", label: "-15\u00b0" },
  { value: "-30", label: "-30\u00b0" },
  { value: "-45", label: "-45\u00b0" },
  { value: "45", label: "45\u00b0" },
];

export const clone = (value) => JSON.parse(JSON.stringify(value));

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());

export const digit = (value) => /^\d*$/.test(value);
